import script from "./RepertoireResearchCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RepertoireResearchCard.vue?vue&type=script&setup=true&lang=js"

import "./RepertoireResearchCard.vue?vue&type=style&index=0&id=7358b532&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7358b532"]])

export default __exports__